export default __webpack_public_path__ + "static/media/francine2.cb8928e7.jpg";